<template>
   <b-modal
    ref="modal-debt-excel"
    hide-footer
    :title="titleExcel"
    id="modal-debt-excel"
    > <b-row class="mb-4"
      > <b-col cols="12"
        > <b-form-group label="Danh sách cần xuất:"
          > <b-form-radio-group v-model="selectedListExcel"
            > <b-form-radio value="all">Tất cả các trang</b-form-radio> <b-form-radio value="filter"
              >Theo bộ lọc</b-form-radio
            > </b-form-radio-group
          > </b-form-group
        > </b-col
      > <b-col cols="12"
        > <b-row v-if="selectedListExcel === 'all'"
          > <b-col md="4"
            > <b-form-group
              > <label>Từ ngày:</label> <date-picker
                placeholder="Từ ngày"
                class="form-control form-control-sm"
                :config="dpConfigs.date"
                v-model="apiParams.fromDate"
              ></date-picker
              > </b-form-group
            > </b-col
          > <b-col md="4"
            > <b-form-group
              > <label>Đến ngày:</label> <date-picker
                placeholder="Tới ngày"
                class="form-control form-control-sm"
                :config="dpConfigs.date"
                v-model="apiParams.toDate"
              ></date-picker
              > </b-form-group
            > </b-col
          > </b-row
        > </b-col
      > </b-row
    > <b-overlay
      :show="isDownloading"
      rounded
      opacity="0.6"
      class="d-inline-block mr-3"
      @hidden="$refs.button.focus()"
      > <template #overlay
        >
        <div class="d-flex align-items-center">
           <b-spinner
            variant="light"
            small
            type="grow"
          ></b-spinner
          >
        </div>
         </template
      > <b-button
        variant="primary"
        size="sm"
        @click="exportToExcelStream"
        > <v-icon
          small
          class="text-white"
          v-b-tooltip
          >mdi-download</v-icon
        > <strong>Xuất Excel</strong> </b-button
      > </b-overlay
    > <b-button
      style="width: 80px"
      variant="secondary"
      size="sm"
      @click="$bvModal.hide('modal-debt-excel')"
      > <strong>Hủy</strong> </b-button
    > </b-modal
  >
</template>

<script>
  import { validationMixin } from 'vuelidate'
  import { mapGetters } from 'vuex'
  import { makeToastFaile } from '@/utils/common'

  import axios from 'axios'
  import datePicker from 'vue-bootstrap-datetimepicker'
  import fileDownload from '@/utils/file-download'
  import { BASE_URL } from '@/utils/constants'
  // Import date picker css
  import { isArray, omitBy } from 'lodash'
  import moment from 'moment'
  import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css'
  export default {
    props: ['param', 'mode'],
    mixins: [validationMixin],
    data() {
      return {
        dpConfigs: {
          date: {
            format: 'DD/MM/YYYY',
            useCurrent: false,
            showClear: true,
            showClose: true,
            minDate: false,
            maxDate: false,
            locale: 'vi',
            sideBySide: true,
          },
        },
        selectedListExcel: 'all',
        apiParams: null,
        titleExcel: 'Xuất excel hoá đơn bán lẻ',
        types: [],
        contactType: null,
        isDownloading: false,
        entityRefType: null,
      }
    },
    components: {
      datePicker,
    },
    computed: {
      ...mapGetters(['checkPermission']),
      /** Quẹt thẻ: dùng API export-excel-credit (mặc định types/contactType phía BE). */
      useExportExcelCredit() {
        return this.mode === 'credits' || this.mode === 'credit-orders'
      },
    },
    created() {},
    watch: {
      $props: {
        handler() {
          switch (this.mode) {
            case 'items':
              this.titleExcel = 'Công nợ trả góp hoá đơn'
              this.types = [4]
              this.contactType = '3'
              this.entityRefType = 1
              break
            case 'warranty-items':
              this.titleExcel = 'Công nợ trả góp bảo hành'
              this.types = [4]
              this.contactType = '3'
              this.entityRefType = 3
              break
            case 'installment-orders':
              this.titleExcel = 'Công nợ trả góp đơn hàng'
              this.types = [4]
              this.contactType = '3'
              this.entityRefType = 2
              break
            case 'credits':
              this.titleExcel = 'Công nợ quẹt thẻ hoá đơn'
              this.contactType = '5'
              this.types = [3]
              this.entityRefType = 1
              break
            case 'credit-orders':
              this.titleExcel = 'Công nợ quẹt thẻ góp đơn hàng'
              this.types = [3]
              this.contactType = '5'
              this.entityRefType = 2
              break
            default:
              this.titleExcel = 'Không xác định'
              break
          }
          this.apiParams = { ...this.param }
        },
        deep: true,
        immediate: true,
      },
    },
    validations: {},
    methods: {
      exportToExcelStream() {
        this.isDownloading = true

        const baseUrl = BASE_URL

        const apiParams = this.getParamFilters()

        if (!apiParams) {
          this.isDownloading = false
          return
        }

        const exportPath = this.useExportExcelCredit
          ? 'v1/debts/export-excel-credit'
          : 'v1/debts/export-excel'

        axios
          .get(`${baseUrl}${exportPath}`, {
            params: {
              ...apiParams,
            },
            responseType: 'blob',
          })
          .then((response) => {
            const fileName = fileDownload.getFileName(response)
            fileDownload.createFile(response.data, fileName)
            this.isDownloading = false
          })
          .catch((err) => {
            this.isDownloading = false
            if (!err.response) {
              // network error
              makeToastFaile('Lỗi!')
            } else {
              const message = err.response.data.message
              makeToastFaile(message)
            }

            this.$nprogress.done()
          })
      },
      getValuesMultiSelect(arr, prop) {
        return (arr || []).reduce((accumulator, currentValue) => {
          if (currentValue.checked) accumulator.push(currentValue[prop])
          return accumulator
        }, [])
      },
      getCreditExcelFilterParams(fromDate, toDate) {
        const p = this.apiParams || {}
        const out = {
          entityRefType: this.entityRefType,
          fromDate,
          toDate,
          storeId: p.storeId,
          customerMobile: p.customerMobile,
          customerName: p.customerName,
          contactId: p.contactId,
          contractCode: p.contractCode,
          docId: p.docId,
          isFullPaid: p.isFullPaid,
        }
        if (this.mode === 'credits' && p.listInvoice && p.listInvoice.length) {
          out.listInvoice = p.listInvoice
        }
        return omitBy(out, (v) => v === null || v === undefined || v === '')
      },
      getParamFilters() {
        const DATE_FORMAT = 'DD/MM/YYYY'
        const DATE_DB_FORMAT = 'YYYY-MM-DD'
        const fromDate = this.apiParams.fromDate
          ? moment(this.apiParams.fromDate, DATE_FORMAT).format(DATE_DB_FORMAT)
          : '1991-01-01'

        const toDate = this.apiParams.toDate
          ? moment(this.apiParams.toDate, DATE_FORMAT).format(DATE_DB_FORMAT)
          : moment().format('YYYY-MM-DD')

        if (this.useExportExcelCredit) {
          if (this.selectedListExcel === 'filter') {
            return this.getCreditExcelFilterParams(fromDate, toDate)
          }
          return omitBy(
            {
              entityRefType: this.entityRefType,
              fromDate,
              toDate,
            },
            (v) => v === null || v === undefined,
          )
        }

        let contactIds = null

        if (!isArray(this.apiParams.contactId)) {
          contactIds = this.apiParams.contactId || null
        } else {
          // contactIds = this.getValuesMultiSelect(
          //   this.apiParams.contactId,
          //   'value'
          // );
          contactIds = this.apiParams.contactId.map(({ value }) => value)
        }

        const apiParams = {
          fromDate: fromDate,
          toDate: toDate,
          types: this.types,
          // contactType: this.contactType,
          entityRefType: this.entityRefType,
          // contactId: contactIds,
        }

        if (this.selectedListExcel === 'filter') {
          const productSearch = this.apiParams.productSearch || ''

          if (productSearch.length < 5 && productSearch.length > 1) {
            makeToastFaile('Tên sản phẩm phải từ 5 kí tự trở lên')
            return null
          }

          const storeIds = this.getValuesMultiSelect(this.apiParams.storeIds, 'code')
          // if (this.apiParams.storeIds.length) {
          //   const storeIds = this.apiParams.storeIds.map(({ code }) => code);
          // }
          let status = null
          if (!isArray(this.apiParams.status)) {
            status = this.apiParams.status || null
          } else {
            status = this.apiParams.status.map(({ value }) => value)
          }

          return {
            ...this.apiParams,
            ...apiParams,
            contactId: contactIds,
            productSearch: productSearch ? productSearch.trim() : null,
            storeIds: storeIds,
            status,
          }
        }

        return apiParams
      },
    },
  }
</script>

